import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationEquipmentOnboardPostBody,
  IConfigurationEquipmentOnboardResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationEquipmentOnboardAPI = () => {
  const [newEquipmentId, setNewEquipmentId] = useState<string>("");
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (equipmentData: IConfigurationEquipmentOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!equipmentData) {
          return;
        }
        await axios
          .post(CONFIGURATION_APIS?.EQUIPMENT_ONBOARD?.baseURL ?? "", equipmentData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationEquipmentOnboardResponse>) => {
            if (res.data.status === true) {
              setNewEquipmentId(res.data.data.equipment_id);
              toast.success(`${equipmentData?.equipment_name} has been onboarded successfully.`);
            } else {
              toast.error("Error while onboarding equipment.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error(axiosError.response?.data?.["message"]);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { newEquipmentId, execute };
};
